import styled from 'styled-components';

const ProgressBarContainer = styled.div`
  position: relative;
  width: ${({ theme }) => (theme.fullWidth ? '100%' : '200px')};

  > div {
    position: relative;
    background: #ececec;
    border-radius: 20px;
    border: 1px solid #d8d8d8;
    box-sizing: content-box;
    height: ${({ theme }) => theme.height}px;
    overflow: hidden;
    transition: all 0.6s ease;

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      height: inherit;
      background: ${({ theme }) => theme.color};
      width: ${({ theme }) => theme.percentage}%;
    }
  }
`;

export default ProgressBarContainer;
export { ProgressBarContainer };
